import React, { useState, useEffect } from 'react';
import { Button, createTheme, ThemeProvider } from '@mui/material';
import Dashboard from './views/dashboard';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Dashboard />
    </ThemeProvider>
  );
}

export default App;
